/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcribe_After_Import_Dont_Ask_AgainInputs */



/**
* | output |
* | --- |
* | "Don't ask again" |
*
* @param {Transcribe_After_Import_Dont_Ask_AgainInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcribe_after_import_dont_ask_again = /** @type {((inputs?: Transcribe_After_Import_Dont_Ask_AgainInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcribe_After_Import_Dont_Ask_AgainInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Don't ask again")
	if (locale === "de") return /** @type {LocalizedString} */ ("Don't ask again")
	if (locale === "it") return /** @type {LocalizedString} */ ("Don't ask again")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Don't ask again")
	if (locale === "es") return /** @type {LocalizedString} */ ("Don't ask again")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Don't ask again")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Don't ask again")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Don't ask again")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Don't ask again")
	return /** @type {LocalizedString} */ ("Don't ask again")
});